export const SITE_PREFIX = "/fasttrack";
export const URL_PREFIX = SITE_PREFIX;
export const MENTORS_URL = `${SITE_PREFIX}/mentors`;
